// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const tipoBancosFullfilledReducer = makeSetReducer(['tipo_bancos/fullfilled']);
